module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [_c('el-button', {
    directives: [{
      name: "create",
      rawName: "v-create:contact",
      value: ({
        customer_id: _vm.customer.id
      }),
      expression: "{customer_id: customer.id}",
      arg: "contact"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "success",
      "size": "mini",
      "icon": "el-icon-plus",
      "circle": ""
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('customer', {
    attrs: {
      "present": "contacts",
      "item": _vm.customer
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-247681e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerContactsSummaryWidget.vue
// module id = 678
// module chunks = 1